import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { string } from 'prop-types';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

// Styles
import { innerBoxTextStyles, titleStyles } from './ConfirmationDialog.styles';

const Message = ({ originator, recipient, transferDate, volume, product, location }) => {
  return (
    <>
      {/* eslint-disable-next-line */}
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} mb="10px">
        {/* eslint-disable-next-line */}
        <Box m={{ xs: '5px', sm: '10px' }}>
          <Typography display="block" fontFamily="Gothic A1" fontWeight={600} variant="caption">
            From
          </Typography>
          <Typography className="css-heap-redact" component="span" sx={{ ...titleStyles }}>
            {originator}
          </Typography>
        </Box>
        {/* eslint-disable-next-line */}
        <Box alignSelf="center" display={{ xs: 'none', sm: 'flex' }}>
          <ChevronRightRoundedIcon sx={{ color: 'text.secondary', fontSize: 36 }} />
        </Box>
        {/* eslint-disable-next-line */}
        <Box m={{ xs: '5px', sm: '10px' }}>
          <Typography display="block" fontFamily="Gothic A1" fontWeight={600} variant="caption">
            To
          </Typography>
          <Typography className="css-heap-redact" component="span" sx={{ ...titleStyles }}>
            {recipient}
          </Typography>
        </Box>
      </Box>
      {/* eslint-disable-next-line */}
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} mb="10px">
        {/* eslint-disable-next-line */}
        <Box m={{ xs: '5px', sm: '10px' }}>
          <Typography component="span" display="block" variant="caption">
            Date
          </Typography>
          <Typography color="textPrimary" component="span" display="block" variant="body1">
            {format(new Date(transferDate || null), 'MMM d, yyyy')}
          </Typography>
        </Box>
        {/* eslint-disable-next-line */}
        <Box m={{ xs: '5px', sm: '10px' }}>
          <Typography component="span" display="block" variant="caption">
            Location
          </Typography>
          <Typography color="textPrimary" component="span" display="block" variant="body1">
            {location}
          </Typography>
        </Box>
      </Box>
      <Box
        alignItems="center"
        bgcolor="primary.light"
        borderRadius="4px"
        display="flex"
        height="45px"
        px={2}
        py={0}
      >
        <Typography color="textPrimary" sx={{ ...innerBoxTextStyles }} variant="subtitle2">
          {volume} {product}
        </Typography>
      </Box>
    </>
  );
};

Message.propTypes = {
  location: string.isRequired,
  originator: string.isRequired,
  product: string.isRequired,
  recipient: string.isRequired,
  transferDate: string.isRequired,
  volume: string.isRequired,
};

export default Message;
